import { create } from "zustand"

import type { WorkflowItem } from "@/api/models"

type PendingWorkflowState = {
  pendingWorkflow: WorkflowItem | null
  setPendingWorkflow: (workflow: WorkflowItem | null) => void
  clearPendingWorkflow: () => void
}

export const usePendingWorkflowStore = create<PendingWorkflowState>((set) => ({
  pendingWorkflow: null,
  setPendingWorkflow: (workflow) => set({ pendingWorkflow: workflow }),
  clearPendingWorkflow: () => set({ pendingWorkflow: null }),
}))
